import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audit-comp',
  templateUrl: './audit-comp.component.html',
  styleUrls: ['./audit-comp.component.css']
})
export class AuditCompComponent {

}
